/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
import { describerResultToPorts } from "./ports.js";
import { GraphQueries } from "./graph-queries.js";
export class Node {
    descriptor;
    #graph;
    #graphId;
    #deleted = false;
    constructor(descriptor, graph, graphId) {
        this.descriptor = descriptor;
        this.#graph = graph;
        this.#graphId = graphId;
    }
    title() {
        return this.descriptor.metadata?.title || this.descriptor.id;
    }
    description() {
        return this.descriptor.metadata?.description || this.title();
    }
    incoming() {
        return new GraphQueries(this.#graph, this.#graphId).incoming(this.descriptor.id);
    }
    outgoing() {
        return new GraphQueries(this.#graph, this.#graphId).outgoing(this.descriptor.id);
    }
    isEntry() {
        return this.incoming().length === 0;
    }
    isExit() {
        return this.outgoing().length === 0;
    }
    type() {
        const type = new GraphQueries(this.#graph, this.#graphId).typeForNode(this.descriptor.id);
        if (!type) {
            throw new Error(`Possible integrity error: node ${this.descriptor.id} does not have a type`);
        }
        return type;
    }
    configuration() {
        return this.descriptor.configuration || {};
    }
    metadata() {
        return this.descriptor.metadata || {};
    }
    async describe(inputs) {
        const describeEntry = this.#graph.describe.get(this.descriptor.id, this.#graphId, inputs);
        return describeEntry.latest;
    }
    currentPorts(inputValues, outputValues) {
        const snapshot = this.#graph.describe.get(this.descriptor.id, this.#graphId);
        return describerResultToPorts(this, snapshot.current, snapshot.updating, inputValues, outputValues);
    }
    async ports(inputValues, outputValues) {
        const described = await this.describe(inputValues);
        return describerResultToPorts(this, described, false, inputValues, outputValues);
    }
    setDeleted() {
        this.#deleted = true;
    }
    deleted() {
        return this.#deleted;
    }
}
//# sourceMappingURL=node.js.map